
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/[lang]/faq",
      function () {
        return require("private-next-pages/mahashivratri/[lang]/faq/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/[lang]/faq"])
      });
    }
  